import { StoreActions } from "@green24/npm-preact-utils/store";

export const applicationActions = new StoreActions("APPLICATION");
export const configurationActions = new StoreActions("CONFIGURATION");
export const settingsActions = new StoreActions("SETTINGS");
export const locationActions = new StoreActions("LOCATION");
